import { Box, Typography } from '@mui/material'
import { plcAudience } from '../../data/plcContent'
import FigmaIconFrame from '../common/FigmaIconFrame'
import { MOBILE_MQ, mobileSectionTitleSx } from '../../theme/mobileLayout'

function AudienceCard({ title, description, iconSrc, iconBgColor }) {
  return (
    <Box
      sx={{
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        minHeight: { xs: 260, lg: 286 },
        boxSizing: 'border-box',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 6, lg: '50px' },
          height: '100%',
        }}
      >
        <FigmaIconFrame src={iconSrc} bgColor={iconBgColor} />
        <Box>
          <Typography
            sx={{
              fontSize: { xs: 22, md: 22 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, md: 16 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
              mt: '12px',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default function PlcAudienceSection() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 5, md: '80px' },
      }}
    >
      <Typography
        component="h2"
        sx={{
          ...mobileSectionTitleSx,
          fontSize: { ...mobileSectionTitleSx.fontSize },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          [MOBILE_MQ]: { fontSize: 22 },
        }}
      >
        Who Should Attend PLC 4.0?
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 3, md: '40px' } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: { xs: 3, md: '40px' },
          }}
        >
          {plcAudience.slice(0, 3).map((item) => (
            <AudienceCard key={item.title} {...item} />
          ))}
        </Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: { xs: 3, md: '40px' },
          }}
        >
          {plcAudience.slice(3, 6).map((item) => (
            <AudienceCard key={item.title} {...item} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
